package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_contact_data_di_ContactModule : Module get() = module {
	single() { _ -> com.essntl.features.contact.data.repository.ContactRepositoryImpl(supabase=get(),contactDataSource=get()) } bind(com.essntl.features.contact.domain.repository.ContactRepository::class)
	single() { _ -> com.essntl.features.contact.data.supabase.ContactSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.contact.data.supabase.ContactSupabaseDataSource::class)
}
public val com.essntl.features.contact.data.di.ContactModule.module : org.koin.core.module.Module get() = com_essntl_features_contact_data_di_ContactModule
